export default __webpack_public_path__ + "static/media/rt-logo.9fae6226.png";